<template>
  <Modal>
    <Modal.Title>Change title</Modal.Title>
    <Modal.Body>
      <Input v-model="title" size="xl" label="Title" :disabled="loading" />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :disabled="loading" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :disabled="!canSave"
        :loading="loading"
        @click="handleSave"
      >
        Save
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Input, Button, useModal } from '@dacr/library'
import type { User } from '@/shared/graphql/legacy/generated'
import { useChangeTitle } from './useChangeTitle'

const { close } = useModal()

const props = defineProps<{
  user: User
}>()

const { title, loading, canSave, save } = useChangeTitle(props.user)

const handleSave = async () => {
  if (await save()) close()
}
</script>
